enum MimeType {
  Json = 'application/json',
  Pdf = 'application/pdf',
}

export default MimeType;
